<template>
  <PageBreadcrumbs :items="breadcrumbs" data-testid="reviews-breadcrumb" />
  <AgencyCompletion :agency="agency" />
  <ContentCard data-testid="agency-view-card">
    <template #header>
      <ReviewsAgencyTabs />
    </template>
    <template #subheader>
      <RouterView :agency="agency" name="subheader" />
    </template>
    <RouterView :agency="agency" />
  </ContentCard>
</template>
<script setup lang="ts">
import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { AgencyCompletion } from '@/components/ProfileCompletion'
import { useReviewsAgencyBreadcrumbs } from '@/composables/breadcrumbs/useReviewsAgencyBreadcrumbs.ts'
import type { AgencyData } from '@/gql/reviews'
import ContentCard from '@/ui/ContentCard.vue'

import ReviewsAgencyTabs from './ReviewsAgencyTabs.vue'

const props = defineProps<{
  agency: AgencyData
}>()

const breadcrumbs = useReviewsAgencyBreadcrumbs(props.agency)
</script>
